(function () {
  if (window.ProductSizeChartModalInitialized) return;
  window.ProductSizeChartModalInitialized = true;

  function getTabs(group) {
    return Array.prototype.slice.call(group.querySelectorAll(".tab"));
  }

  function getTabPanels(group) {
    var chart = group.closest(".size-chart");
    return chart ? Array.prototype.slice.call(chart.querySelectorAll(".tab-content")) : [];
  }

  function activateTab(group, selectedTab) {
    var tabs = getTabs(group);
    var panels = getTabPanels(group);
    var selectedIndex = tabs.indexOf(selectedTab);

    if (selectedIndex < 0) return;

    tabs.forEach(function (tab, index) {
      var isActive = index === selectedIndex;
      tab.classList.toggle("active", isActive);
      tab.setAttribute("role", "tab");
      tab.setAttribute("aria-selected", String(isActive));
      tab.setAttribute("tabindex", isActive ? "0" : "-1");
    });

    panels.forEach(function (panel, index) {
      var isActive = index === selectedIndex;
      panel.classList.toggle("active", isActive);
      panel.hidden = !isActive;
      panel.setAttribute("role", "tabpanel");
    });
  }

  function initializeModal(modal) {
    modal.querySelectorAll("[data-size-guide-page-content] .tabs").forEach(function (group) {
      var tabs = getTabs(group);
      if (!tabs.length) return;

      group.setAttribute("role", "tablist");
      var activeTab = group.querySelector(".tab.active") || tabs[0];
      activateTab(group, activeTab);
    });
  }

  function scrollToChart(modal, link) {
    var targetId = (link.getAttribute("href") || "").replace(/^#/, "");
    if (!targetId) return;

    var target = document.getElementById(targetId);
    var modalBody = modal.querySelector(".modal-body");
    if (!target || !modalBody || !modal.contains(target)) return;

    var targetTop = target.getBoundingClientRect().top - modalBody.getBoundingClientRect().top + modalBody.scrollTop;
    modalBody.scrollTo({ top: Math.max(targetTop - 12, 0), behavior: "smooth" });
  }

  document.addEventListener("click", function (event) {
    var modal = event.target.closest("[data-size-chart-modal]");
    if (!modal) return;

    var tab = event.target.closest("[data-size-guide-page-content] .tab");
    if (tab) {
      var group = tab.closest(".tabs");
      if (group) {
        event.preventDefault();
        activateTab(group, tab);
      }
      return;
    }

    var navigationLink = event.target.closest("[data-size-guide-page-content] .nav-brands-btn[href^='#']");
    if (navigationLink) {
      event.preventDefault();
      scrollToChart(modal, navigationLink);
    }
  });

  document.addEventListener("shown.bs.modal", function (event) {
    if (event.target.matches("[data-size-chart-modal]")) {
      initializeModal(event.target);
    }
  });

  document.addEventListener("hidden.bs.modal", function (event) {
    if (!event.target.matches("[data-size-chart-modal]")) return;
    var modalBody = event.target.querySelector(".modal-body");
    if (modalBody) modalBody.scrollTop = 0;
  });

  document.querySelectorAll("[data-size-chart-modal]").forEach(initializeModal);
})();
